import McPieChart from './McPieChart';

export default McPieChart;
